<template>
	<div class="wrap">
		<div class="insidebanner">
			<img src="../assets/download/42645589_2l.jpg" alt="">
			<span class="insidebanner-bor"></span>
		</div>
		<div class="content">
			<div class="content-title">
				<h4>APP下载</h4>
				<img src="../assets/download/app_download.png" alt="">
			</div>
			<div class="content-cont">
				<div class="content-cont-l">
					<div class="content-cont-lt">
						<p><span class="redbor">柚子通</span></p>
						<p><span class="yellowbor">覆盖三端的互联网平台</span></p>
						<p><span class="bluebor">全面赋能幼教行业</span></p>
					</div>
					<div class="content-cont-lb">
						<div class="youzitong-teacher">
							<img class="youzitong-logo" src="../assets/download/teacher.png" alt="">
							<p class="youzitong-name">柚子通-教师端</p>
							<div @click="show=!show">
								<img class="youzitong-store" src="../assets/download/apple.png" alt="">
								<img class="youzitong-store" src="../assets/download/android.png" alt="">
							</div>
							<transition name="fade">
								<img v-if="show" src="../assets/download/code_teacher.png" alt="">
							</transition>
						</div>
						<div class="youzitong-parents">
							<img class="youzitong-logo" src="../assets/download/parents.png" alt="">
							<p class="youzitong-name">柚子通-家长端</p>
							<div @click="show2=!show2">
								<img class="youzitong-store" src="../assets/download/apple.png" alt="">
								<img class="youzitong-store" src="../assets/download/android.png" alt="">
							</div>
							<transition name="fade">
								<img v-if="show2" src="../assets/download/code_parents.png" alt="">
							 </transition>
						</div>
					</div>
				</div>
				<div class="content-cont-r">
					<img src="../assets/download/pic.png" alt="">
				</div>
			</div>
			
		</div>
	</div>
</template>
<script>
	export default {
		name: 'DownLoad',
		data () {
			return {
				show: false,
				show2: false
			}
		},
		methods: {
// 			hanldShow: function() {
// 				this.show = !this.show
// 			}
		}
	}
</script>
<style lang="scss" scoped>
	@import '../base/scss/mixin';
	.fade-enter-active, .fade-leave-active {
		  transition: opacity .5s;
		}
		.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		  opacity: 0;
		}
	.content {
		padding-top: 60px;
		background: url(../assets/download/download_bg.jpg) center top no-repeat;
		&-title {
			text-align: center;
			margin-bottom: 60px;
			h4 {
				margin-bottom: 8px;
				font-weight: normal;
				font-size: 28px;
				color: #1d50a2;
			}
		}
		&-cont {
			@extend %width;
			@extend %clearfix;
			&-r {
				float: right;
				width: 480px;
			}
			&-l {
				float: left;
				width: 520px;
				padding-left: 90px;
				padding-top: 20px;
			}
			&-lt {
				padding-bottom: 66px - 42px;
				p {
					margin-bottom: 42px;
					span {
						display: inline-block;
						padding-bottom: 6px;
						border-bottom: 7px solid;
						font-size: 28px;
					}
				}
				.redbor {
					border-bottom-color: #e7364b;
				}
				.yellowbor {
					border-bottom-color: #e3b020;
				}
				.bluebor {
					border-bottom-color: #091338;
				}
			}
			&-lb {
				@extend %clearfix;
				.youzitong-teacher,
				.youzitong-parents {
					float: left;
					text-align: center;
					font-size: 16px;
					img {
						display: block;
						margin-left: auto;
						margin-right: auto;
					}
				}
				.youzitong-teacher {
					margin-right: 90px;
				}
				.youzitong-logo {
					margin-bottom: 25px;
				}
				.youzitong-name {
					margin-bottom: 18px;
				}
				.youzitong-store {
					margin-bottom: 24px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/DownLoad.vue